import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeConfig } from './config/theme.config';
import { Provider as ReduxProvider} from 'react-redux';
import { store } from './redux/store';
import { MsalProvider } from '@azure/msal-react'
import { msalConfig } from './helpers/EntraID/authConfig';
import { PublicClientApplication } from '@azure/msal-browser';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const msalInstance = new PublicClientApplication(msalConfig);

// root.render(
//   <React.StrictMode>
//     <ReduxProvider store={store}>
//       <ThemeConfig>
//         <App />
//       </ThemeConfig>
//     </ReduxProvider>
//   </React.StrictMode>
// );

root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <ThemeConfig>
        <App />
      </ThemeConfig>
    </MsalProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
